<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Manage Inventory
      </h6>

      <div class="container-fluid">
        <div style="border: 0; padding: 0; min-height: 0" class="navbar background_color">
          <div class="d-flex inventory-toolbar">
            <b-input-group size="sm" style="width: 225px;">
              <b-form-input
                v-model="globalFilter"
                type="search"
                placeholder="Search all columns"
                class="bdr-rad"
              />
            </b-input-group>
            <button
              type="button"
              class="ai-search-trigger"
              v-b-tooltip.hover
              title="AI Search"
              aria-label="AI Search"
              @click="showAiSearchModal = true"
            >
              <svg viewBox="0 0 24 24" class="ai-search-icon-svg" aria-hidden="true">
                <defs>
                  <linearGradient id="aiSearchGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#57b2ff" />
                    <stop offset="100%" stop-color="#0d6efd" />
                  </linearGradient>
                </defs>
                <path
                  fill="url(#aiSearchGradient)"
                  d="M12 2.2l1.77 5.73L19.5 9.7l-5.73 1.77L12 17.2l-1.77-5.73L4.5 9.7l5.73-1.77L12 2.2z"
                />
                <path
                  fill="none"
                  stroke="url(#aiSearchGradient)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.4"
                  d="M5.8 16.5c.9-1.2 2.1-2 3.7-2.4"
                />
                <circle cx="18.1" cy="5.1" r="1.2" fill="#0d6efd" />
              </svg>
            </button>
            <div style="margin-top: 11px" class="ms-2 inventory-count">
              <span class="custom-breadcrumb">
                Showing {{ pageStart }}-{{ pageEnd }} of {{ filteredInventories.length }} items.
              </span>
            </div>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else class="table-responsive">
              <b-table
                responsive
                class="table-hover"
                style="font-size: small"
                :items="filteredInventories"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                head-variant="dark"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                show-empty
                small
                :tbody-tr-class="rowClass"
              >
                <template #head(SKU)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.SKU" size="sm" placeholder=" SKU" class="header-filter" />
                  </div>
                </template>

                <template #head(Name)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Name" size="sm" placeholder=" Name" class="header-filter" />
                  </div>
                </template>

                <template #head(Location)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Location" size="sm" placeholder=" Location" class="header-filter" />
                  </div>
                </template>

                <template #head(Price)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Price" size="sm" placeholder=" Price" class="header-filter" />
                  </div>
                </template>

                <template #head(Winery)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Winery" size="sm" placeholder=" Winery" class="header-filter" />
                  </div>
                </template>

                <template #head(Country)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Country" size="sm" placeholder=" Country" class="header-filter" />
                  </div>
                </template>

                <template #head(Region)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Region" size="sm" placeholder=" Region" class="header-filter" />
                  </div>
                </template>

                <template #head(Varietal)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Varietal" size="sm" placeholder=" Varietal" class="header-filter" />
                  </div>
                </template>

                <template #head(Type)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Type" size="sm" placeholder=" Type" class="header-filter" />
                  </div>
                </template>

                <template #head(Body)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Body" size="sm" placeholder=" Body" class="header-filter" />
                  </div>
                </template>

                <template #head(Description)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Description" size="sm" placeholder=" Description" class="header-filter" />
                  </div>
                </template>

                <template #head(Qty)="data">
                  <div class="header-stack">
                    <div class="header-label">{{ data.label }}</div>
                    <b-form-input v-model="columnFilters.Qty" size="sm" placeholder=" Qty" class="header-filter" />
                  </div>
                </template>

                <template #cell(SKU)="row">
                  <button
                    type="button"
                    class="inventory-link"
                    :title="`View bin card for ${row.item.SKU || 'this item'}`"
                    @click="openPreview(row.item)"
                  >
                    {{ row.item.SKU || '-' }}
                  </button>
                </template>

                <template #cell(Name)="row">
                  <button
                    type="button"
                    class="inventory-link inventory-name-link"
                    :title="`View bin card for ${row.item.Name || row.item.product_name || 'this item'}`"
                    @click="openPreview(row.item)"
                  >
                    {{ row.item.Name || row.item.product_name || '-' }}
                  </button>
                </template>

                <template #cell(Photo)="row">
                  <img
                    v-if="row.item.Photo"
                    :src="photoUrl(row.item.Photo)"
                    alt="Photo"
                    class="inventory-photo"
                  />
                  <span v-else>-</span>
                </template>

                <template #cell(Price)="row">
                  <span v-if="row.item.Price !== null && row.item.Price !== undefined && row.item.Price !== ''">
                    {{ formatPrice(row.item.Price) }}
                  </span>
                  <span v-else>-</span>
                </template>

                <template #cell(Description)="row">
                  <button
                    type="button"
                    class="inventory-link"
                    title="View description"
                    @click="openDescription(row.item)"
                  >
                    View
                  </button>
                </template>

              

                <template #cell(actions)="row">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary bdr-rad"
                    @click="openBinCard(row.item)"
                  >
                    View Bin Card
                  </button>
                </template>
              </b-table>

              <b-col style="padding-left: 0" sm="7" md="2" class="my-1 mb-4">
                <b-pagination v-model="currentPage" pills :total-rows="filteredInventories.length" :per-page="perPage" size="sm" />
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ai-description-search-modal
      v-model="showAiSearchModal"
      :access-token="access_token"
      endpoint="/dinventory/ai-search"
    />

    <b-modal
      id="dinventory-preview-modal"
      v-model="showPreviewModal"
      size="lg"
      hide-footer
      centered
      title="Inventory Preview"
      @hidden="selectedItem = {}"
      >
      <div class="row">
        <div class="col-md-4 mb-3 text-center">
          <img
            v-if="selectedItem.Photo"
            :src="photoUrl(selectedItem.Photo)"
            class="preview-photo"
            alt="Photo"
          />
          <div v-else class="preview-photo placeholder-box">No Photo</div>
        </div>
        <div class="col-md-8">
          <table class="table table-sm table-borderless" style="font-size: small">
            <tbody>
              <tr><td><b>SKU</b></td><td>{{ selectedItem.SKU }}</td></tr>
              <tr><td><b>Name</b></td><td>{{ selectedItem.product_name || selectedItem.Name }}</td></tr>
              <tr><td><b>Store Location</b></td><td>{{ selectedItem.Location || selectedItem.StoreLocation }}</td></tr>
              <tr><td><b>Price</b></td><td>{{ formatPrice(selectedItem.Price) }}</td></tr>
              <tr><td><b>Winery</b></td><td>{{ selectedItem.Winery }}</td></tr>
              <tr><td><b>Country</b></td><td>{{ selectedItem.Country }}</td></tr>
              <tr><td><b>Region</b></td><td>{{ selectedItem.Region }}</td></tr>
              <tr><td><b>Varietal</b></td><td>{{ selectedItem.Varietal }}</td></tr>
              <tr><td><b>Type</b></td><td>{{ selectedItem.Type }}</td></tr>
              <tr><td><b>Body</b></td><td>{{ selectedItem.Body }}</td></tr>
              <tr><td><b>Description</b></td><td>{{ selectedItem.Description }}</td></tr>
              <tr><td><b>Qty</b></td><td>{{ selectedItem.Qty }}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="text-end">
        <button type="button" class="btn btn-outline-primary bdr-rad" @click="showPreviewModal = false">Close</button>
      </div>
    </b-modal>

    <b-modal
      id="dinventory-description-modal"
      v-model="showDescriptionModal"
      hide-footer
      centered
      title="Description"
      @hidden="selectedDescription = ''"
    >
      <div class="description-popup-content">
        {{ selectedDescription || 'No description available.' }}
      </div>
      <div class="text-end mt-3">
        <button
          type="button"
          class="btn btn-outline-primary bdr-rad"
          @click="showDescriptionModal = false"
        >
          Close
        </button>
      </div>
    </b-modal>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';
import AiDescriptionSearchModal from './../../components/AiDescriptionSearchModal.vue';

export default {
  components: {
    TopNavbar,
    ContentFooter,
    AiDescriptionSearchModal,
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      inventories: [],
      globalFilter: '',
      showAiSearchModal: false,
      columnFilters: {
        SKU: '',
        Name: '',
        Location: '',
        Price: '',
        Winery: '',
        Country: '',
        Region: '',
        Varietal: '',
        Type: '',
        Body: '',
        Description: '',
        Qty: '',
      },
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      currentPage: 1,
      perPage: 15,
      isLoading: true,
      showPreviewModal: false,
      selectedItem: {},
      showDescriptionModal: false,
      selectedDescription: '',
      fields: [
        { key: 'SKU', label: 'SKU', sortable: true },
        { key: 'Name', label: 'Name', sortable: true },
        { key: 'Location', label: 'Store Location', sortable: true },
        { key: 'Photo', label: 'Photo', sortable: false },
        { key: 'Price', label: 'Price', sortable: true },
        { key: 'Winery', label: 'Winery', sortable: true },
        { key: 'Country', label: 'Country', sortable: true },
        { key: 'Region', label: 'Region', sortable: true },
        { key: 'Varietal', label: 'Varietal', sortable: true },
        { key: 'Type', label: 'Type', sortable: true },
        { key: 'Body', label: 'Body', sortable: true },
        { key: 'Description', label: 'Description', sortable: true },
        { key: 'Qty', label: 'Qty', sortable: true },
        { key: 'actions', label: 'Actions', class: 'width-custom8' },
      ],
    };
  },
  mounted() {
    this.loadInventories();
  },
  computed: {
    filteredInventories() {
      const globalNeedle = this.normalizeFilter(this.globalFilter);

      return this.inventories.filter((item) => {
        if (globalNeedle) {
          const searchable = [
            item.SKU,
            item.Name,
            item.Location,
            item.Price,
            item.Winery,
            item.Country,
            item.Region,
            item.Varietal,
            item.Type,
            item.Body,
            item.Description,
            item.Qty,
          ].join(' ').toLowerCase();

          if (!searchable.includes(globalNeedle)) {
            return false;
          }
        }

        return Object.keys(this.columnFilters).every((key) => {
          const needle = this.normalizeFilter(this.columnFilters[key]);
          if (!needle) {
            return true;
          }

          const value = this.normalizeFilter(item[key]);
          return value.includes(needle);
        });
      });
    },
    pageStart() {
      if (this.filteredInventories.length === 0) {
        return 0;
      }

      return ((this.currentPage - 1) * this.perPage) + 1;
    },
    pageEnd() {
      return Math.min(this.currentPage * this.perPage, this.filteredInventories.length);
    },
  },
  watch: {
    globalFilter() {
      this.currentPage = 1;
    },
    columnFilters: {
      deep: true,
      handler() {
        this.currentPage = 1;
      },
    },
  },
  methods: {
    normalizeFilter(value) {
      return String(value == null ? '' : value).trim().toLowerCase();
    },
    formatPrice(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }

      const amount = Number(value);
      return Number.isNaN(amount) ? '$' + value : '$' + amount.toFixed(2);
    },
    photoUrl(path) {
      if (!path) {
        return '';
      }

      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
      }

      return path.startsWith('/') ? path : '/' + path;
    },
    openPreview(item) {
      this.selectedItem = item || {};
      this.showPreviewModal = true;
    },
    openBinCard(item) {
      if (!item || !item.id) {
        return;
      }

      this.$router.push({
        path: '/dinventory/bin-card',
        query: { id: item.id },
      });
    },
    openDescription(item) {
      this.selectedDescription = item && item.Description ? item.Description : '';
      this.showDescriptionModal = true;
    },
    rowClass() {
      return '';
    },
    async loadInventories() {
      try {
        const { data } = await axios.get('/dinventory/index', {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-Type': 'application/json',
          },
        });
        this.inventories = (data.all_data || []).map((item) => ({
          ...item,
          Location: item.Location || item.StoreLocation || '',
        }));
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.bdr-rad {
  border-radius: 12px;
}

.bdr-rad2 {
  border-radius: 15px;
}

.decoration {
  text-decoration: none;
  color: white !important;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}

.inventory-photo,
.preview-photo {
  width: 54px;
  height: 54px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #d6d6d6;
}

.preview-photo {
  width: 100%;
  height: 300px;
}

.placeholder-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f7f7;
  color: #666;
}

.description-popup-content {
  min-height: 140px;
  padding: 18px;
  border: 1px solid #d7e5f5;
  border-radius: 12px;
  background: #f8fbff;
  color: #253b53;
  line-height: 1.65;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.photo-button {
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
}

.inventory-toolbar {
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.inventory-count {
  display: flex;
  align-items: center;
}

.ai-search-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid #0d6efd;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(13, 110, 253, 0.12);
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.ai-search-trigger:hover {
  transform: translateY(-1px);
  background: #f5f9ff;
  box-shadow: 0 10px 22px rgba(13, 110, 253, 0.18);
}

.ai-search-trigger:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.18);
}

.ai-search-icon-svg {
  width: 24px;
  height: 24px;
}

.header-stack {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 110px;
}

.header-label {
  line-height: 1.1;
  font-weight: 600;
}

.header-filter {
  min-width: 110px;
}

.inventory-link {
  display: inline;
  padding: 0;
  border: 0;
  background: transparent;
  color: #075fcf;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}

.inventory-link:hover,
.inventory-link:focus {
  color: #00449b;
}

.inventory-link:focus {
  outline: 2px solid rgba(13, 110, 253, 0.35);
  outline-offset: 2px;
  border-radius: 2px;
}

.inventory-name-link {
  max-width: 220px;
  white-space: normal;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 992px) {
  .header-stack,
  .header-filter {
    min-width: 95px;
  }
}

@media (max-width: 768px) {
  .container-fluid {
    padding-left: 8px;
    padding-right: 8px;
  }

  .navbar .d-flex {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .navbar .b-input-group {
    width: 100% !important;
  }

  .custom-breadcrumb {
    display: block;
    margin-top: 0 !important;
    margin-left: 0 !important;
  }

  .inventory-toolbar {
    gap: 8px;
  }

  .ai-search-trigger {
    width: 38px;
    height: 38px;
    border-radius: 12px;
  }

  .card {
    padding: 6px !important;
  }

  .card-body {
    padding: 8px !important;
  }

  .b-table {
    font-size: 12px !important;
  }

  .b-table th,
  .b-table td {
    padding: 0.4rem 0.45rem !important;
    vertical-align: middle;
  }

  .header-stack {
    min-width: 85px;
    gap: 4px;
  }

  .header-filter {
    min-width: 85px;
    font-size: 12px;
  }

  .inventory-photo {
    width: 42px;
    height: 42px;
  }

  .btn-sm {
    padding: 0.22rem 0.45rem;
    font-size: 0.78rem;
  }
}

@media (max-width: 576px) {
  .manage-boder {
    font-size: 12px !important;
    line-height: 1.4;
  }

  .header-stack {
    min-width: 78px;
  }

  .header-filter {
    min-width: 78px;
  }

  .inventory-photo {
    width: 36px;
    height: 36px;
  }
}
</style>
